import { StateAssert } from '@csp/csp-common-model';
import {
  GenericRequest,
  GenericRequestMapper,
  ScheduleCode,
  ScheduleValidationService,
  VersionCode,
} from '@csp/csp-common-scheduling';
import { ConsentRequestV1 } from '@csp/dmdp-api-consent-dto';
import { toConfigFromMetaV1 } from '../mapper/ConsentRequestMetaMapper';
import { ConsentRequestConfigMeta } from './ConsentRequestConfigMeta';
import { ConsentRequestDetails } from './ConsentRequestDetails';

export type ConsentRequestInfo = GenericRequest<ConsentRequestDetails> & {
  meta: ConsentRequestConfigMeta;
};

const from = (
  scheduleCode: ScheduleCode,
  versionCode: VersionCode,
  { requestCode, details, meta, timing }: ConsentRequestV1,
): ConsentRequestInfo => {
  StateAssert.notNull(details, `Details must be set. RequestCode: ${requestCode}`);

  const request: ConsentRequestInfo = {
    requestCode,
    versionCode,
    scheduleCode,
    details: details ? ConsentRequestDetails.from(details) : undefined,
    meta: toConfigFromMetaV1(meta),
    timing: GenericRequestMapper.toTiming(timing),
  };

  ScheduleValidationService.validateRequest(request);
  return request;
};

export const ConsentRequestInfo = {
  from,
};
